import { httpClient } from '@bcba/client-auth';
import { UpsertCompanyContactInformationDto } from '../dto';
import { CompanyContactInformationSerializer } from '@bcba/serializers';
import { basePath } from '.';

export const updateCompanyContactInfo = async (
  dto: UpsertCompanyContactInformationDto,
) => {
  const { data } = await httpClient.put<CompanyContactInformationSerializer>(
    `${basePath}/contact-information`,
    dto,
  );

  return data;
};
